<template>
  <div :class="{ cutoff: cutOffList }">{{ sortedQualifications }}</div>
</template>
<script>
import { defineComponent, computed } from "vue";
import { sortBy } from "lodash-es";
import gql from "fraql";

export default defineComponent({
  name: "AppShowProfQualificationsList",
  props: {
    profQualifications: {
      type: Array,
      default: () => []
    },
    limitList: {
      type: Number,
      default: 0
    },
    cutOffList: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const sortedQualifications = computed(() => {
      let qs = props.profQualifications;
      qs = sortBy(qs, "rank").map(x => x.name);
      if (props.limitList && props.limitList < qs.length) {
        qs = qs.splice(0, props.limitList);
      }
      return qs.join(", ");
    });
    return { sortedQualifications };
  },
  fragments: {
    profQualificationFields: gql`
      fragment _ on ProfQualification {
        id
        name
        rank
      }
    `
  }
});
</script>
<style scoped>
.cutoff {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 700px;
}
</style>
